import { createReducer, on } from '@ngrx/store';
import {
  generatePsyTest,
  generatePsyTestSuccess,
  generatePsyTestFailure,
  savePsyTestAnswersFailure,
  savePsyTestAnswersSuccess,
  savePsyTestAnswers,
  fetchPsyTestReportFailure,
  fetchPsyTestReportSuccess, fetchPsyTestReport
} from './psyTesting.actions';

export interface PsyTestingState {
  loading: boolean;
  result: any;
  error: any;
}

export const initialState: PsyTestingState = {
  loading: false,
  result: null,
  error: null,
};

export const psyTestingReducer = createReducer(
  initialState,
  on(generatePsyTest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(generatePsyTestSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    result,
  })),
  on(generatePsyTestFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(savePsyTestAnswers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(savePsyTestAnswersSuccess, (state, { result }) => ({
    ...state,
    loading: false,
    result,
  })),
  on(savePsyTestAnswersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  })),
  on(fetchPsyTestReport, (state) => ({
    ...state,
    loading: true,
    reportError: null,
  })),
  on(fetchPsyTestReportSuccess, (state, { report }) => ({
    ...state,
    loading: false,
    report,
  })),
  on(fetchPsyTestReportFailure, (state, { error }) => ({
    ...state,
    loading: false,
    reportError: error,
  })),
);
